import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { verifyPin, pinScope } from "@/lib/pin";
import { Lock, WifiOff } from "lucide-react";

export default function OfflinePinGate() {
  const { locked, unlock, user, logout } = useAuth();
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  if (!locked) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (await verifyPin(pin, pinScope(user))) { setErr(""); unlock(); }
    else { setErr("Code PIN incorrect."); setPin(""); }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-[#0B182B] p-6" data-testid="pin-gate">
      <div className="w-full max-w-sm text-center text-white">
        <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-4"><Lock className="w-7 h-7 text-[#60A5FA]" /></div>
        <h1 className="text-xl font-bold font-head">Déverrouiller Biashara</h1>
        <p className="text-sm text-white/60 mt-1 flex items-center justify-center gap-1.5"><WifiOff className="w-3.5 h-3.5" /> Hors connexion · {user?.name}</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input type="password" inputMode="numeric" autoFocus value={pin} onChange={(e) => setPin(e.target.value)}
            placeholder="Code PIN" data-testid="pin-input"
            className="w-full text-center tracking-[0.5em] text-lg bg-white/10 rounded-xl px-4 py-3 outline-none focus:bg-white/20" />
          {err && <p className="text-sm text-[#FCA5A5]" data-testid="pin-error">{err}</p>}
          <button type="submit" className="btn-primary w-full !py-3" data-testid="pin-submit">Déverrouiller</button>
        </form>
        <button onClick={logout} className="text-xs text-white/50 hover:text-white mt-5" data-testid="pin-logout">Se connecter avec un autre compte (en ligne)</button>
      </div>
    </div>
  );
}
